module.exports = __webpack_public_path__ + "img/mind_template_item_1_4.65868846.png";